module.exports = __webpack_public_path__ + "static/media/execute_PP2.53bd5b79.png";